import {NgModule} from '@angular/core';
import {LgModule} from "./lg/lg.module";
import {RpModule} from "./rp/rp.module";
import {SiModule} from "./si/si.module";

@NgModule({
    exports: [
        LgModule,
        RpModule,
        SiModule
    ]
})
export class FeaturePowerModule {
}